var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgForms = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#C6E1FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_4307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 19.9998C11.6667 16.0715 11.6667 14.1073 12.8871 12.8869C14.1075 11.6665 16.0717 11.6665 20.0001 11.6665C23.9285 11.6665 25.8926 11.6665 27.113 12.8869C28.3334 14.1073 28.3334 16.0715 28.3334 19.9998C28.3334 23.9282 28.3334 25.8924 27.113 27.1128C25.8926 28.3332 23.9285 28.3332 20.0001 28.3332C16.0717 28.3332 14.1075 28.3332 12.8871 27.1128C11.6667 25.8924 11.6667 23.9282 11.6667 19.9998Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 20.8335H14.3003C15.0546 20.8335 15.4318 20.8335 15.7633 20.986C16.0948 21.1385 16.3403 21.4248 16.8312 21.9975L17.3357 22.5861C17.8266 23.1588 18.072 23.4452 18.4035 23.5977C18.7351 23.7502 19.1122 23.7502 19.8665 23.7502H20.1336C20.8879 23.7502 21.2651 23.7502 21.5966 23.5977C21.9281 23.4452 22.1736 23.1588 22.6645 22.5861L23.169 21.9975C23.6599 21.4248 23.9054 21.1385 24.2369 20.986C24.5684 20.8335 24.9456 20.8335 25.6999 20.8335H28.3334",
    stroke: "#1D1D1D",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 15.8335H23.3334",
    stroke: "#1D1D1D",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 18.75H21.6666",
    stroke: "#1D1D1D",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_4307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgForms);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/forms.bb8ebe13eab087cebaf24f9a88fb6228.svg";